import activity from './activity.de.json';
import assets from './assets.de.json';
import auth from './auth.de.json';
import commissions from './commissions.de.json';
import common from './common.de.json';
import dashboard from './dashboard.de.json';
import payouts from './payouts.de.json';
import profile from './profile.de.json';
import rewards from './rewards.de.json';
import rewardsV3 from './rewardsV3.de.json';
import shareLink from './shareLink.de.json';
import stats from './stats.de.json';
import transactions from './transactions.de.json';

const de = {
  activity,
  assets,
  auth,
  commissions,
  common,
  dashboard,
  payouts,
  profile,
  rewards,
  rewardsV3,
  shareLink,
  stats,
  transactions,
};

export default de;
